import { render } from "./UsersDataTable.vue?vue&type=template&id=0f9cd21c"
import script from "./UsersDataTable.vue?vue&type=script&lang=js"
export * from "./UsersDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__